import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureFlagRepository, FeatureName } from '../../core/state';
import { map, take } from 'rxjs';

/**
 * Only allow navigation when a specified Feature Flag is enabled;
 * otherwise redirect the user to the root of the app
 * @param feature Feature Flag name that must be enabled
 * @constructor
 */
export const featureFlagGuard = (feature: FeatureName, fallbackRoute: string[] = ['/'], redirectIfEnabled = false): CanActivateFn => {
  return () => {
    const router = inject(Router);
    const featureFlagRepo = inject(FeatureFlagRepository);
    return featureFlagRepo.isFeatureEnabled$(feature).pipe(
      take(1),
      map((isFeatureEnabled) => {
        let shouldRedirect = false;
        if (redirectIfEnabled) {
          shouldRedirect = isFeatureEnabled;
        } else {
          shouldRedirect = !isFeatureEnabled;
        }
        return !shouldRedirect || router.createUrlTree(fallbackRoute);
      }),
    );
  };
};
